var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import PropTypes from 'prop-types';
import styled, { css, keyframes } from 'styled-components';
import { Flex } from '..';
import { applySizes, getPaletteColor } from '../utils';
var sizes = {
    small: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 48px;\n    height: 48px;\n\n    & > svg {\n      width: 20px;\n      height: 20px;\n    }\n  "], ["\n    width: 48px;\n    height: 48px;\n\n    & > svg {\n      width: 20px;\n      height: 20px;\n    }\n  "]))),
    medium: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    width: 64px;\n    height: 64px;\n\n    & > svg {\n      width: 24px;\n      height: 24px;\n    }\n  "], ["\n    width: 64px;\n    height: 64px;\n\n    & > svg {\n      width: 24px;\n      height: 24px;\n    }\n  "]))),
    large: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    width: 96px;\n    height: 96px;\n\n    & > svg {\n      width: 36px;\n      height: 36px;\n    }\n  "], ["\n    width: 96px;\n    height: 96px;\n\n    & > svg {\n      width: 36px;\n      height: 36px;\n    }\n  "]))),
};
var RelativeFlex = styled(Flex)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  position: relative;\n\n  ", ";\n"], ["\n  position: relative;\n\n  ", ";\n"])), applySizes(sizes, null));
var rotate = keyframes(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n"], ["\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n"])));
var Ring = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border: 2px solid ", ";\n  border-top: 2px solid ", ";\n  border-radius: 50%;\n  animation: ", " 1s linear infinite;\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border: 2px solid ", ";\n  border-top: 2px solid ", ";\n  border-radius: 50%;\n  animation: ", " 1s linear infinite;\n"])), getPaletteColor('base'), getPaletteColor('background.lightest'), rotate);
var propTypes = {
    children: PropTypes.node,
    color: PropTypes.string,
    size: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.oneOf(Object.keys(sizes)),
        PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf(Object.keys(sizes)), PropTypes.string, PropTypes.number])),
    ]),
};
var Spinner = function (_a) {
    var _b;
    var children = _a.children, color = _a.color, props = __rest(_a, ["children", "color"]);
    if (children) {
        React.Children.only(children);
    }
    return (React.createElement(RelativeFlex, __assign({ justifyContent: 'center', alignItems: 'center' }, props),
        React.createElement(Ring, { color: color }),
        children &&
            React.cloneElement(children, {
                color: ((_b = children === null || children === void 0 ? void 0 : children.props) === null || _b === void 0 ? void 0 : _b.color) || color,
            })));
};
Spinner.propTypes = propTypes;
Spinner.defaultProps = {
    color: 'primary',
    size: 'medium',
};
export default Spinner;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=Spinner.js.map